import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const ipReportStatus = createAsyncThunk('ipReportStatus/ipReportStatus', async (data) => {
    try {
        const res = await axios({
            method: 'GET',
            url: process.env.REACT_APP_API_URL + `ip_details`,
            params: {
                 type: data.type,
                 link_id: data.link_id,
            },
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${localStorage.getItem("token")}`
            }
        })
        return res
    } catch (error) {
        return error.response || { status: 500, data: { message: 'Network error or timeout' } }
    }
})

const ipReportStatusSlice = createSlice({
    name: 'ipReportStatus',
    initialState: {
        data: null,
        loading: false,
        error: null,
    },
    extraReducers: (builder) => {
        builder.addCase(ipReportStatus.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(ipReportStatus.fulfilled, (state, action) => {
            state.loading = false;
            if (action?.payload?.status === 200) {
                state.data = action.payload.data.data;
                state.error = null;
            } else if (action?.payload?.status === 401) {
                state.data = null;
                state.error = 'Unauthorized';
                localStorage.clear();
                action?.meta?.arg?.navigate('../login')
            } else {
                state.error = action.payload?.data?.message || 'Failed to fetch link analysis';
                state.data = null;
            }
        });
        builder.addCase(ipReportStatus.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error?.message || 'An error occurred';
            state.data = null;
        });
    }
})

export default ipReportStatusSlice.reducer;

